import { atom } from 'jotai';

export const UPGRADE_FEATURES = [
  'csv-download',
  'treemap',
  'transition',
  'saved-filter',
  'alert',
  'themes',
] as const;

export type UpgradeFeature = (typeof UPGRADE_FEATURES)[number];
export type UpgradeTier = 'plus' | 'business';

export type UpgradeModalState = {
  isOpen: boolean;
  feature: UpgradeFeature;
  tier: UpgradeTier;
};

export const upgradeModalAtom = atom<UpgradeModalState>({
  isOpen: false,
  feature: 'csv-download',
  tier: 'plus',
});
